import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  FullTable,
  MinLoader,
  PriceRow,
  CustomNumericFormat, DateSelector, TabButtons,
} from 'components';
import { Colors, FindLoad, FindSuccessItem, Images } from 'utils';
import { carrierActions, httpRequestsOnSuccessActions } from 'store';
import { RESERVE_ACTION_TYPE, reserveBody, reserveHead, reserveTabParams, reserveTabTypeEnums } from './constants';

const ACTION_TYPE = 'CHANGE_RESERVE_PERCENT';
export const Reserve = ({}) => {
  const { reserveList, carrierById } = useSelector((state) => ({
    reserveList: state.carriers.reserveList,
    carrierById: state.carriers.carrierById,
  }));
  const history = useHistory();
  const info = history?.location?.state;
  const [editReserve, setEditReserve] = useState(false);
  const [percent, setPercent] = useState(0);
  const dispatch = useDispatch();
  const params = useParams();
  const loader = FindLoad(ACTION_TYPE);
  const success = FindSuccessItem(ACTION_TYPE);
  const getReserveList = ( ) => {
    const filteredInfo = {
      ...info,
    };
    filteredInfo.skip = info?.skip ? info?.skip : 0;
    filteredInfo.limit = 100;
    filteredInfo.state = info?.viewType ?  info?.viewType : reserveTabTypeEnums.PENDING;
    delete filteredInfo.page;
    delete filteredInfo.activeTab;
    delete filteredInfo.vendorType;
    dispatch(carrierActions.getReserve(params?.id, filteredInfo));
  };

  useEffect(() => {
    getReserveList('loading');
  }, [info]);

  useEffect(() => {
    if(success){
      setEditReserve(false)
      dispatch(httpRequestsOnSuccessActions.removeSuccess(ACTION_TYPE))
    }
  }, [success])

  useEffect(() => {
    if (carrierById) {
      setPercent(carrierById?.reserve?.percent);
    }
  }, [carrierById]);

  useEffect(() => {
  }, [dispatch]);

  const saveReserve = () => {
    if ((percent || percent === 0) && percent !== carrierById?.reserve?.percent) {
      dispatch(carrierActions.changeReservePercent(params?.id, { percent: percent }));
    }
  };

  return (
    <div>
      <div className="space-between">
        <div className="space-between">
          <TabButtons
            tabParams={reserveTabParams}
            resetParams={true}
            resetSaveParams={{
              activeTab: info?.activeTab
            }}
          />
          <DateSelector
            startName={'from'}
            endName={'to'}
          />
        </div>
      </div>

      <div className="reserve-wrapper">
        <p className="reserve-total-title">Totals</p>

        <div className="align-center" style={{ gap: 16 }}>
          <div className="reserve-row-box active-reserve" style={{ minWidth: 250 }}>
            <p className="reserve-row-title">Reserve:</p>
            <p className="reserve-row-value">
              <PriceRow info={reserveList?.total} />
              {/*<PriceRow info={carrierById?.reserve?.keptAmount} />*/}
            </p>
          </div>
          <div className="reserve-row-box total-reserve" style={{ minWidth: 250 }}>
            <p className="reserve-row-title">Reserve used:</p>
            <p className="reserve-row-value">
              <PriceRow info={carrierById?.reserve?.chargedAmount} />
            </p>
          </div>

          {editReserve ?
            <div className="reserve-input-box fixed-reserve-input" style={{ width: 220 }}>
              <CustomNumericFormat
                name={'percent'}
                value={percent}
                handleChangeMiles={(e) => setPercent(e.floatValue)}
                decimalScale={1}
                isAllowed={(values) => {
                  const { floatValue } = values;
                  return floatValue === undefined || floatValue <= 100;
                }}
              />
              <div>
                <button
                  onClick={saveReserve}
                  style={{ marginTop: 1, width: 18, height: 26 }}
                >
                  {loader?.length ?
                    <MinLoader
                      margin={'-3px 0 0 0'}
                      color={Colors.ThemeGreen}
                      position={'relative'}
                      style={{ width: 16, height: 16 }}
                    />
                    :
                    <img src={Images.checkGreen} alt="checkmark" />
                  }
                </button>
                <button onClick={() => setEditReserve(false)}>
                  <img style={{ height: 18, width: 18 }} src={Images.removeRed} alt="remove" />
                </button>
              </div>
            </div>
            :
            <div className="reserve-row-box fixed-reserve" style={{ width: 220 }}>
              <p className="reserve-row-title">Reserve %:</p>
              <p className="reserve-row-value">{percent || 0}</p>
              <button
                onClick={() => setEditReserve(true)}
                className="reset-btn"
                style={{ marginLeft: '4px' }}
              >
                <img src={Images.edit} alt="edit" />
              </button>
            </div>
          }
        </div>
      </div>

      <FullTable
        head={reserveHead(info?.viewType)}
        body={reserveBody((info?.viewType))}
        loadingType={RESERVE_ACTION_TYPE}
        list={reserveList?.loads}
        listCount={reserveList?.count}
        noText={'Reserve'}
      />
    </div>
  );
};